
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCollisionAvoidanceOvertaking as ObiCollisionAvoidanceOvertakingElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-collision-avoidance-overtaking.js';
 
 
 

 
 export const ObiCollisionAvoidanceOvertaking = createComponent({
   react: React,
   tagName: 'obi-collision-avoidance-overtaking',
   elementClass: ObiCollisionAvoidanceOvertakingElement,
   events: {
     
   }
  });
 
 